module.exports = __webpack_public_path__ + "img/badge-gold.1ef3684e.svg";